import React from 'react';
import './footer.styles.scss';

const Footer = () => {
    return(
        <div className="footer-container">
            <span>Demo Shop by <a href="https://www.linkedin.com/in/eudinson-uy-6970a1128/" target="_blank"  rel="noreferrer" className="eudin">Eudin</a></span>
        </div>
    )
}

export default Footer;